module.exports = __webpack_public_path__ + "static/thibault-rouet-c18051aea2b831e728013f21143eb613.jpg";